import type {
  InsightListData,
  JourneyTimelineData,
  NarrativeBlockData,
  NumberedInsightListData,
} from '../../types';
import { attachMockRegistryToInsights } from '../mockRegistryMeta';

const rawInsightResultsMock: Record<
  string,
  JourneyTimelineData | InsightListData | NumberedInsightListData | NarrativeBlockData
> = {
  customer_journey_timeline: {
    display_name: 'Nessim went quiet for a year. Then he came back for a new F-150 lease.',
    customerName: 'Nessim',
    summaryStats: [
      { label: 'FIRST INQUIRY', value: 'Mar 2025', detail: 'Older used F-150' },
      { label: 'SOLD', value: 'Apr 2026', detail: 'New 2026 F-150 lease' },
      { label: 'DAYS NURTURED', value: '373' },
      { label: 'TOUCHES', value: '18' },
    ],
    milestones: [
      { date: 'Mar 2025', title: 'Inquired', detail: 'Internet up' },
      { date: 'Apr 2025', title: 'Went silent' },
      { date: 'May-Dec 2025', title: '8 nurturing touches' },
      { date: 'Jan-Mar 2026', title: 'Engaged', detail: 'F-150 content' },
      { date: 'Apr 2026', title: 'Returned, leased new', isHighlight: true },
    ],
    footer:
      'Interest evolved upward over time — from an older used truck to a new lease. The nurturing kept the door open across 373 days of silence, and when Nessim was ready, the conversation picked up right where it left off.',
  } as JourneyTimelineData,
  inventory_watchlist: {
    display_name: "What we're paying attention to",
    items: [
      {
        title: 'F-150 inventory tight',
        description:
          'Continuing to surface CPO and higher-trim units with discount offers where main trims are constrained.',
        affectsLabel: 'Affects 4,142 F-150 prospects',
        category: 'Trim flex',
        iconVariant: 'warning',
      },
      {
        title: '14 aged Bronco Sport units >90 days',
        description: 'Pushing these to first-time-buyer and lease-shopper profiles.',
        affectsLabel: 'Est. reach: 1,800 prospects',
        category: 'Aged stock',
        iconVariant: 'clock',
      },
      {
        title: 'Super Duty inventory healthy',
        description: 'Doubling up on trade-up framing with finance offers.',
        affectsLabel: 'Est. pool 920',
        category: 'Trade-up',
        iconVariant: 'trend',
      },
    ],
  } as InsightListData,
  discussion_item_packet: {
    display_name: 'Discussion items',
    items: [
      {
        summary: 'Phone-up channel conversion dropped to 0.2%',
        detail:
          'Significant gap vs. best-in-class. Worth a sales-team conversation about phone follow-up discipline before June.',
      },
      {
        summary: 'Devon K. is flagged on email and VOI capture',
        detail:
          "Capture rates roughly half of team average — a chance to recover ~30 prospects/month that currently can't be nurtured.",
      },
      {
        summary: '“Priced-to-move” content is your highest converter',
        detail:
          '11 of 36 revival sales touched this theme. Worth considering whether the dealership can flag inventory for this treatment more proactively.',
      },
      {
        summary: 'No lease or finance offers available for F-150 and Bronco Sport',
        detail: 'High interest segment. Needs offers to get buyers more interested.',
      },
    ],
  } as NumberedInsightListData,
  monthly_focus_narrative: {
    display_name: "Doubling down on what's already working — and watching the trim gaps.",
    overline: 'HEADING INTO THIS MONTH',
    headline: "Doubling down on what's already working — and watching the trim gaps.",
    description:
      "Current month's focus is F-150, Super Duty, Bronco, and Bronco Sport. That's where 78% of nurturing pool is available — so the nurturing plan leans the same direction.",
  } as NarrativeBlockData,
};

export const insightResultsMock = attachMockRegistryToInsights(rawInsightResultsMock);
